<div class="main-container">

    <!-- LEFT SECTION -->
    <div>

        <div class="progress-box">
            <div class="progress-title">Challenging projects</div>

            <div class="progress-bar">
                <div class="progress-fill width-98"></div>
            </div>
        </div>

        <div class="progress-box">
            <div class="progress-title">Award winning team</div>

            <div class="progress-bar">
                <div class="progress-fill width-80"></div>
            </div>
        </div>

        <div class="progress-box">
            <div class="progress-title">Creative environment</div>

            <div class="progress-bar">
                <div class="progress-fill width-92"></div>
            </div>
        </div>

        <h2 class="section-title">RA Information</h2>

        <ul class="info-list">

            <li>
                <span class="info-label">
                    Name of the Recruiting Agent:
                </span>

                <div class="info-value">
                    SB CONSULTANCY
                </div>
            </li>

            <li>
                <span class="info-label">
                    Name of the RC Holder:
                </span>

                <div class="info-value">
                    Mr.R.SUNDAR
                </div>
            </li>

            <li>
                <span class="info-label">
                    RC Number:
                </span>

                <div class="info-value">
                    B-3418/TN/PER/100/5/11423/2026
                </div>
            </li>
            <li>
                <span class="info-label">
                    RC Validity Status:
                </span>

                <div class="info-value">
                    
                     Issued on 18-05-2026 valid till 20-02-2031
                </div>
            </li>

            <li>
                <span class="info-label">
                    RA ID:
                </span>

                <div class="info-value">
                    RA6425334
                </div>
            </li>

            <li>
                <span class="info-label">
                    RA Address:
                </span>

                <div class="info-value">
                    SHOP NO B11 AND B12 AKILA COMPLEX
                </div> <br>
                <div class="info-value">
                    ODATHURAI STREET, THIRUVAIYARU,
                </div> <br>
                <div class="info-value">
                    THANJAVUR-613204,TAMIL NADU.
                </div>
            </li>

            <li>
                <span class="info-label">
                    Contact:
                </span>

                <div class="info-value">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg>
                   <span id="contact">Tele/Fax:04362 260060</span> 
                </div>
            </li>

            <li>
                <span class="info-label">
                    E-mail:
                </span>


                <div class="info-value">
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at" viewBox="0 0 16 16">
  <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"/>
  <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/>
</svg>            <a href="mailto:sbconsultancytnj@gmail.com" class="email-link">
             
                        sbconsultancytnj@gmail.com
                    </a>
                </div>
            </li>

        </ul>

    </div>

    <!-- MIDDLE SECTION -->
    <div class="middle-section">

        <h2 class="section-title">
            Service Charge Information
        </h2>

        <ul class="info-list">

            <li>
                <span class="info-label">
                    Recruitment for ECR Countries:
                </span>

                <div class="charge-text">
                    Fee/Charge - INR 30,000 Maximum
                </div>
            </li>

            <li>
                <span class="info-label">
                    Recruitment for ECNR Countries:
                </span>

                <div class="charge-text">
                    Fee/Charge - INR 30,000 Maximum
                </div>
            </li>

            <li>
                <span class="info-label">
                    Recruitment for Unskilled Workers:
                </span>

                <div class="charge-text">
                    Fee/Charge – INR 30,000 Maximum
                </div>
            </li>

            <li>
                <span class="info-label">
                    Recruitment for Skilled Workers:
                </span>

                <div class="charge-text">
                    Fee/Charge – INR 30,000 Maximum
                </div>
            </li>

            <li>
                <span class="info-label">
                    Recruitment for highly Skilled Professional:
                </span>

                <div class="charge-text">
                    Fee/Charge – INR 30,000 Maximum
                </div>
            </li>

        </ul>

        <h3 class="section-title">
    Mode of Payment of Service Charges
</h3>

<div class="payment-content">

    <p class="payment-heading">
        Service charges can be made only through the following modes
    </p>

    <ol class="payment-list">

        <li>
            Cheque (Post Dated Cheques are not accepted)
        </li>

        <li>
            Net banking/NEFT/RTGS
        </li>

        <li>
            Deposit In Bank Account
        </li>

        <li>
            Demand drafts in favor of SB CONSULTANCY
             payable at THANJAVUR
        </li>

    </ol>

    <div class="warning-text">
        *We Do Not Accept Cash Transactions*
    </div>

</div>

    </div>

    <!-- RIGHT SECTION -->
    <div class="contact-section">

        <h2 class="section-title">
            Grievance Redressal
        </h2>

        <ul class="info-list">


            <li>
                <span class="info-label">
                    Name of Contact Person:
                </span>

                <div class="info-value">
                    MR. SUNDAR </div>
            </li>

            <li>
                <span class="info-label">
                    Email ID:
                </span>

                <div class="info-value">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at" viewBox="0 0 16 16">
  <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"/>
  <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/>
</svg>
                         <a href="mailto:sbconsultancytnj@gmail.com" class="email-link" >

                                
                                 sbconsultancytnj@gmail.com
                        </a>
                </div>
            </li>

            <li>
                <span class="info-label">
                    Mobile Number (Call & Whatsapp):
                </span>

                <div class="info-value" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
</svg>              
                     <span id="contact"> +91 7402555888</span>
                  
                </div>
            </li>

        </ul>

    </div>

</div>